
import dataVisual from './dataviews/dataVisual';
import angleIcon from './dataviews/angleIcon';

let component = {
  dataVis: dataVisual,
  angleIcon
};

const install = (Vue) => {
  Object.keys(component).forEach((key) => {
    Vue.component(`x-${key}`, component[key]);
  });
};

export default Object.assign({}, component, { install });
